var _defs, _rect, _text, _text2, _rect2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCarbonAssessment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .card { fill: #FFFFFF; stroke: rgba(76,175,80,0.10); filter: url(#shadow); }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 800; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n      .step { fill: #CBD5E1; }\r\n      .stepActive { fill: url(#gBlue); }\r\n      .input { fill: #FFFFFF; stroke: rgba(148,163,184,0.9); }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1400,
    height: 800
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 80,
    y: 95,
    fontSize: 34
  }, "Carbon Footprint Assessment (Web)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 80,
    y: 130,
    fontSize: 16
  }, "A guided stepper that collects activity data and outputs total CO\u2082, ESG scope breakdown, and recommendations.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 80,
    y: 170,
    width: 1240,
    height: 560,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,220)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 14
  }, "Steps"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,22)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stepActive",
    x: 0,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 175,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 350,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 525,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 700,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 875,
    y: 0,
    width: 165,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "step",
    x: 1050,
    y: 0,
    width: 70,
    height: 10,
    rx: 5
  })), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 62,
    fontSize: 12
  }, "Energy"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 190,
    y: 62,
    fontSize: 12
  }, "Water/Waste"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 370,
    y: 62,
    fontSize: 12
  }, "Transport"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 545,
    y: 62,
    fontSize: 12
  }, "Materials"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 720,
    y: 62,
    fontSize: 12
  }, "Process"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 895,
    y: 62,
    fontSize: 12
  }, "Controls"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 1050,
    y: 62,
    fontSize: 12
  }, "Results"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,320)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 18
  }, "Energy consumption"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 28,
    fontSize: 14
  }, "Capture monthly electricity + fuel usage; the model applies emission factors and computes Scope 1/2/3."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,55)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Monthly Electricity Consumption (kWh)"), /*#__PURE__*/React.createElement("rect", {
    className: "input",
    x: 0,
    y: 10,
    width: 520,
    height: 52,
    rx: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 44,
    fontSize: 14
  }, "e.g., 12,000")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,55)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Electricity Source"), /*#__PURE__*/React.createElement("rect", {
    className: "input",
    x: 0,
    y: 10,
    width: 520,
    height: 52,
    rx: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 44,
    fontSize: 14
  }, "Grid (Coal-based) v")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,140)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Monthly Fuel Consumption (liters)"), /*#__PURE__*/React.createElement("rect", {
    className: "input",
    x: 0,
    y: 10,
    width: 520,
    height: 52,
    rx: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 44,
    fontSize: 14
  }, "e.g., 950")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,140)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Fuel Type"), /*#__PURE__*/React.createElement("rect", {
    className: "input",
    x: 0,
    y: 10,
    width: 520,
    height: 52,
    rx: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 44,
    fontSize: 14
  }, "Diesel v")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,545)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1080,
    height: 145,
    rx: 20,
    fill: "rgba(33,150,243,0.06)",
    stroke: "rgba(33,150,243,0.20)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 38,
    fontSize: 16
  }, "What the MSME gets at the end"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 66,
    fontSize: 13
  }, "Total CO\u2082, carbon score, ESG scope split (1/2/3), category breakdown, and a recommended action list."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22,85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 44,
    rx: 14,
    fill: "url(#gGreen)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 28,
    fontSize: 14,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Calculate footprint"), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 0,
    width: 170,
    height: 44,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 28,
    fontSize: 14,
    fill: "#1A202C",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Back"), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 0,
    width: 170,
    height: 44,
    rx: 14,
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 28,
    fontSize: 14,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Next")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCarbonAssessment);
export default __webpack_public_path__ + "static/media/product-carbon-assessment.2ecee49edca0d2ca53a1da6c61d0520c.svg";
export { ForwardRef as ReactComponent };